import {
    Component,
    Input,
    OnInit,
    Output,
    ViewChild,
    EventEmitter
} from '@angular/core';
import { TableViewModel } from '@components/models/table';
import { ContractorService } from '@services/contractor.service';
import { ResponsibleService } from '@services/responsible.service';
import { RouteService } from '@services/route.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-load-data',
    templateUrl: './load-data.component.html',
    styleUrls: ['./load-data.component.scss']
})
export class LoadDataComponent implements OnInit {
    @ViewChild('fileInput') fileInput: any;
    @Input()
    data: any = [];

    currentPage: number = 1;
    pageSize: number = 5;
    searchby: string = 'fullname';

    dataExternal: any[] = [];
    filteredData: any[] = [];

    typeFile: string = '';

    @Output() cancelEvent = new EventEmitter<any>();
    @Output() reloadTable = new EventEmitter<any>();

    dataExternalModel: TableViewModel = {
        title: '',
        description: '',
        filter: {
            page: 1,
            pageSize: 5
        },
        fields: [],
        records: [],
        totalRecords: [],
        showFilters: true,
        enableActions: false,
        removeCard: true
    };

    ngOnInit(): void {
        this.dataExternalModel.fields = this.data.fields;
        this.dataExternalModel.description = this.data.description;
    }

    constructor(
        private toast: ToastrService,
        private responsibleService: ResponsibleService,
        private contractorService: ContractorService,
        private routeService: RouteService
    ) { }

    handlingSave = async () => {
        if (this.dataExternal.length === 0) {
            this.toast.error('No hay datos para guardar');
            return;
        }
        if (this.typeFile === 'responsibles') {
            const response_responsibles = await this.responsibleService.loadResponsibles(this.dataExternal);
            if (response_responsibles) {
                this.toast.success('Responsables cargados correctamente');
                this.cancelEvent.emit();
                this.reloadTable.emit();
            }
        } else if (this.typeFile === 'contractors') {
            const response_contractors = await this.contractorService.loadContractors(this.dataExternal);
            if (response_contractors) {
                this.toast.success('Contratistas cargados correctamente');
                this.cancelEvent.emit();
                this.reloadTable.emit();
            }
        } else if (this.typeFile === 'routes') {
            const response_routes = await this.routeService.loadRoutes(this.dataExternal);
            if (response_routes) {
                this.toast.success('Rutas cargadas correctamente');
                this.cancelEvent.emit();
                this.reloadTable.emit();
            }
        }
    };

    handlingCancel = () => {
        this.cancelEvent.emit();
    };

    searchEvent(event: any) {
        const searchText = event.toLowerCase();

        this.filteredData = this.dataExternal.filter((item: any) => {
            const fullNameMatch = item['fullname']
                ?.toString()
                .toLowerCase()
                .includes(searchText);
            const nameMatch = item['name']
                ?.toString()
                .toLowerCase()
                .includes(searchText);
            return fullNameMatch || nameMatch;
        });
        this.currentPage = 1;
        this.updateDisplayedRecords(this.filteredData);
    }

    paginatorEvent(event: any) {
        const data = this.getCurrentData();
        const totalPages = Math.ceil(data.length / this.pageSize);
        this.currentPage = Math.min(event, totalPages);
        this.updateDisplayedRecords(data);
    }

    pageSizeEvent(event: any) {
        this.pageSize = event;
        this.currentPage = 1;
        this.updateDisplayedRecords(this.getCurrentData());
    }

    getTotal(event: any) {
        this.dataExternal = event.data;
        this.typeFile = event.typeFile;
        this.filteredData = [];
        this.updateDisplayedRecords(this.dataExternal);
        console.log(this.dataExternal);
    }

    private getCurrentData(): any[] {
        return this.filteredData.length > 0
            ? this.filteredData
            : this.dataExternal;
    }

    private updateDisplayedRecords(data: any[]) {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + Number.parseInt(this.pageSize as any, 10);

        this.dataExternalModel.records = data.slice(startIndex, endIndex);
        this.dataExternalModel.totalRecords = data;

        this.dataExternalModel.pagination = {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            pageCount: Math.ceil(data.length / this.pageSize),
            rowCount: data.length
        };
    }
}
